import React from "react";

function Settings() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 text-gray-100">
      <div className="max-w-md w-full p-6 rounded-2xl bg-slate-800 shadow-lg">
        <h1 className="text-2xl font-semibold mb-4">Settings</h1>
        <p className="text-sm mb-4">
          Here you can update preferences.
        </p>

        <div className="space-y-3 text-sm">
          <div className="flex items-center justify-between">
            <span>Personalization</span>
            <span className="px-3 py-1 rounded-full bg-slate-700 text-xs">
              Coming soon
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span>Notifications</span>
            <span className="px-3 py-1 rounded-full bg-slate-700 text-xs">
              Coming soon
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span>Language</span>
            <span className="px-3 py-1 rounded-full bg-slate-700 text-xs">
              Coming soon
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span>Delete Account</span>
            <span className="px-3 py-1 rounded-full bg-red-700 text-xs">
              Send us an email
            </span>
          </div>
        </div>

        <a
          href="/"
          className="inline-block mt-6 text-sm underline text-blue-400"
        >
          ⬅ Back to chat
        </a>
      </div>
    </div>
  );
}

export default Settings;
